import { IconCheckOutline18 as Check } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/cn"
import { CommandItem } from "@productlane/ui/src/components/internal/command"

import type { SharedFilterItemsProps } from "@/components/filters"
import { useCompanyAttributeValues } from "@/lib/use-company-attribute-values"
import { useCompaniesFilterState } from "../companies-filter-state"

export function TierFilterItems({ onSelect }: SharedFilterItemsProps) {
	const { tiers, addTier, removeTier } = useCompaniesFilterState()

	const { tiers: availableTiers } = useCompanyAttributeValues()

	if (availableTiers.length === 0) {
		return (
			<div className="py-4 text-center text-sm text-secondary">
				No tiers found
			</div>
		)
	}

	return (
		<>
			{availableTiers.map((tier) => {
				const isSelected = tiers.includes(tier)
				return (
					<CommandItem
						key={tier}
						onSelect={() => {
							if (isSelected) {
								removeTier(tier)
							} else {
								addTier(tier)
							}
							onSelect()
						}}
					>
						<div className="flex w-full items-center gap-2">
							<span className="flex-1 truncate">{tier}</span>
							<Check
								className={cn("h-4 w-4 shrink-0", {
									"opacity-100": isSelected,
									"opacity-0": !isSelected,
								})}
							/>
						</div>
					</CommandItem>
				)
			})}
		</>
	)
}
